import { useMemo } from "react";
import { Button, Bell, RestaurantBar } from "../../../ui";
import { daysUntil } from "../../utils/ludDocuments.helpers";

export default function RestaurantTabs({
  restaurants = [],
  selectedId,
  onSelect,
  isAdmin,
  onAdmin,
  lang,
}) {
  const activeRestaurant = useMemo(() => {
    const index = restaurants.findIndex(
      (restaurant) => (restaurant._id || restaurant.id) === selectedId,
    );

    return index >= 0 ? index : 0;
  }, [restaurants, selectedId]);

  const restaurantStatus = useMemo(() => {
    return restaurants.reduce((acc, restaurant, index) => {
      const cr = (restaurant.orgDocs || []).find((document) => document.key === "cr");
      const crExpiryDays = daysUntil(cr?.expiryDate);
      const pendingUpdates = (restaurant.updates || []).filter((request) =>
        ["new", "in_progress"].includes(request.status),
      ).length;

      const criticalCount =
        (restaurant.essentialMissing?.length || 0) +
        (restaurant.plan !== "L" ? restaurant.dailyMissing?.length || 0 : 0) +
        (crExpiryDays !== null && crExpiryDays < 0 ? 1 : 0);

      const warningCount =
        (restaurant.monthlyMissing?.length || 0) +
        (restaurant.hasItemSales ? restaurant.itemSalesMissing?.length || 0 : 0) +
        pendingUpdates +
        (crExpiryDays !== null && crExpiryDays >= 0 && crExpiryDays <= 30 ? 1 : 0);

      const key = restaurant._id || restaurant.id || index;

      acc[key] = {
        hasYellowMiss: criticalCount > 0,
        hasGrayMiss: warningCount > 0,
        count: criticalCount + warningCount,
      };

      return acc;
    }, {});
  }, [restaurants]);

  return (
    <RestaurantBar
      restaurants={restaurants}
      activeRestaurant={activeRestaurant}
      onRestaurantChange={(_, restaurant) =>
        onSelect?.(restaurant._id || restaurant.id)
      }
      getRestaurantKey={(restaurant, index) =>
        restaurant._id || restaurant.id || index
      }
      getRestaurantLabel={(restaurant) =>
        restaurant.store?.businessName ||
        restaurant.businessName ||
        restaurant.name ||
        "Restaurant"
      }
      getRestaurantStatus={(restaurant, index) => {
        const key = restaurant._id || restaurant.id || index;
        const status = restaurantStatus[key] || {};

        return {
          hasYellowMiss: status.hasYellowMiss,
          hasGrayMiss: status.hasGrayMiss,
          count: status.count,
          countTitle: "pending",
        };
      }}
      actions={
        isAdmin&&<Button
          type="button"
          icon={<Bell size={18} />}
          appearance="soft"
          rounded
          title={lang === "ar" ? "نظرة إدارية شاملة" : "Admin overview"}
          onClick={onAdmin}
        />
      }
    />
  );
}
